import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useReveal } from '../../hooks/useReveal';
import { Search, PenTool, Code2, Link2, Brain, LayoutDashboard, Map, MessageSquare } from 'lucide-react';

const Services = () => {
  const { t } = useLanguage();
  const [ref, visible] = useReveal();

  const services = [
    { icon: Search, key: 's1' },
    { icon: PenTool, key: 's2' },
    { icon: Code2, key: 's3' },
    { icon: Link2, key: 's4' },
    { icon: Brain, key: 's5' },
    { icon: LayoutDashboard, key: 's6' },
    { icon: Map, key: 's7' },
    { icon: MessageSquare, key: 's8' },
  ];

  return (
    <section id="services" ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0A1628]">{t('services.title')}</h2>
          <div className="w-16 h-1 bg-[#00B4D8] mx-auto mt-6 rounded-full" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} data-testid={`service-card-${i}`}
                className={`group bg-[#F8FAFC] border border-slate-100 rounded-xl p-6 hover:bg-[#0A1628] hover:border-[#0A1628] transition-all duration-400 cursor-default ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                style={{ transitionDelay: visible ? `${80 + i * 60}ms` : '0ms' }}>
                <div className="w-11 h-11 bg-[#00B4D8]/10 group-hover:bg-[#00B4D8]/20 rounded-lg flex items-center justify-center mb-4 transition-colors">
                  <Icon className="w-5 h-5 text-[#00B4D8]" />
                </div>
                <p className="font-semibold text-sm text-[#0A1628] group-hover:text-white transition-colors">{t(`services.${s.key}`)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
